import script from "./GmxConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxConfirm.vue?vue&type=script&setup=true&lang=js"

import "./GmxConfirm.vue?vue&type=style&index=0&id=260c1678&lang=scss&scoped=true"
import "./GmxConfirm.vue?vue&type=style&index=1&id=260c1678&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260c1678"]])

export default __exports__